import { fetchShippingStructure } from '~/api/shipping'

const state = {
  shippingStructure: [],
  isLoaded: false,
}

const mutations = {
  SET_SHIPPING_STRUCTURE(state, payload) {
    state.shippingStructure = payload
    state.isLoaded = true
  },
}

const actions = {
  async loadShippingStructure({ commit, state }) {
    if (!state.isLoaded) {
      const shippingStructure = await fetchShippingStructure()
      commit('SET_SHIPPING_STRUCTURE', shippingStructure)
    }
  },
}

const getters = {
  getShippingStructure(state) {
    return state.shippingStructure
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
